module.exports = __webpack_public_path__ + "img/services-cloud.2f6539d.jpg";